<template>
  <modal ref="modal" :modal-backdrop="true">
    <template #body>
      <div class="text-center">
        <div class="text-gray-700 text-lg mx-auto mb-4 max-w-xs">
          Precisa de ajuda com alguma funcionalidade da ah.life?
        </div>
        <div class="text-gray-700 text-md mb-6">
          Vamos lhe direcionar para nossa central de atendimento, onde você poderá tirar todas as suas dúvidas com nossos especialistas.
        </div>
        <button type="button" class="btn-primary-invert font-normal" @click.prevent="closeModalSupport">Cancelar</button>
        <button type="button" class="btn-primary font-normal ml-1" @click.prevent="confirmSupport">Suporte</button>
      </div>
    </template>
  </modal>
</template>

<script>
import { ref } from 'vue'
import Modal from '@/Shared/Modal/Modal'

export default {
  components: {
    Modal,
  },
  setup() {
    const modal = ref(null)

    const openModalSupport = () => {
      modal.value.showModal = true
    }

    const closeModalSupport = () => {
      modal.value.showModal = false
    }

    const confirmSupport = async () => {
      try {
        const res = await fetch('/support/open')
        const json = await res.json()
        window.open(json.link, '_blank')
        closeModalSupport()
      } catch (e) {
        console.error('Erro ao abrir suporte:', e)
      }
    }

    return {
      modal,
      openModalSupport,
      closeModalSupport,
      confirmSupport
    }
  }
}
</script>
